module.exports = require("././angular-translate-storage-cookie.js");


//////////////////
// WEBPACK FOOTER
// angular-translate-storage-cookie (bower component)
// module id = 1004
// module chunks = 1